import { ActionTypes } from "./constants";

const setData = (data) => ({ type: ActionTypes.SET_DATA, payload: data });
const setFilterData = (filterData) => ({ type: ActionTypes.SET_FILTER_DATA, payload: filterData });
const editDataById = (data) => ({ type: ActionTypes.EDIT_DATA_BY_ID, payload: data });

const setData2 = (data) => ({ type: ActionTypes.SET_DATA2, payload: data });
const setFilterData2 = (filterData) => ({ type: ActionTypes.SET_FILTER_DATA2, payload: filterData });

const exports = { 
    setData,
    setFilterData,
    editDataById,

    setData2,
    setFilterData2,
}
export default exports
